import strike_eagle_card160 from "../assets/photos/strike_eagle-160.jpg";
import strike_eagle_card320 from "../assets/photos/strike_eagle-320.jpg";
import strike_eagle_card640 from "../assets/photos/strike_eagle-640.jpg";
import strike_eagle_hero640 from "../assets/photos/strike_eagle-hero-640.jpg";
import strike_eagle_hero1200 from "../assets/photos/strike_eagle-hero-1200.jpg";
import strike_eagle_hero2000 from "../assets/photos/strike_eagle-hero-2000.jpg";
import hornet_sunset_card160 from "../assets/photos/hornet_sunset-160.jpg";
import hornet_sunset_card320 from "../assets/photos/hornet_sunset-320.jpg";
import hornet_sunset_card640 from "../assets/photos/hornet_sunset-640.jpg";
import hornet_sunset_hero640 from "../assets/photos/hornet_sunset-hero-640.jpg";
import hornet_sunset_hero1200 from "../assets/photos/hornet_sunset-hero-1200.jpg";
import hornet_sunset_hero2000 from "../assets/photos/hornet_sunset-hero-2000.jpg";
import f15_card160 from "../assets/photos/f15-160.jpg";
import f15_card320 from "../assets/photos/f15-320.jpg";
import f15_card640 from "../assets/photos/f15-640.jpg";
import f15_hero640 from "../assets/photos/f15-hero-640.jpg";
import f15_hero1200 from "../assets/photos/f15-hero-1200.jpg";
import f15_hero2000 from "../assets/photos/f15-hero-2000.jpg";
import flanker_card160 from "../assets/photos/flanker-160.jpg";
import flanker_card320 from "../assets/photos/flanker-320.jpg";
import flanker_card640 from "../assets/photos/flanker-640.jpg";
import flanker_hero640 from "../assets/photos/flanker-hero-640.jpg";
import flanker_hero1200 from "../assets/photos/flanker-hero-1200.jpg";
import flanker_hero2000 from "../assets/photos/flanker-hero-2000.jpg";
import a10_formation_card160 from "../assets/photos/a10_formation-160.jpg";
import a10_formation_card320 from "../assets/photos/a10_formation-320.jpg";
import a10_formation_card640 from "../assets/photos/a10_formation-640.jpg";
import a10_formation_hero640 from "../assets/photos/a10_formation-hero-640.jpg";
import a10_formation_hero1200 from "../assets/photos/a10_formation-hero-1200.jpg";
import a10_formation_hero2000 from "../assets/photos/a10_formation-hero-2000.jpg";
import apache_card160 from "../assets/photos/apache-160.jpg";
import apache_card320 from "../assets/photos/apache-320.jpg";
import apache_card640 from "../assets/photos/apache-640.jpg";
import apache_hero640 from "../assets/photos/apache-hero-640.jpg";
import apache_hero1200 from "../assets/photos/apache-hero-1200.jpg";
import apache_hero2000 from "../assets/photos/apache-hero-2000.jpg";
import blackshark_card160 from "../assets/photos/blackshark-160.jpg";
import blackshark_card320 from "../assets/photos/blackshark-320.jpg";
import blackshark_card640 from "../assets/photos/blackshark-640.jpg";
import blackshark_hero640 from "../assets/photos/blackshark-hero-640.jpg";
import blackshark_hero1200 from "../assets/photos/blackshark-hero-1200.jpg";
import blackshark_hero2000 from "../assets/photos/blackshark-hero-2000.jpg";
import fulcrum_card160 from "../assets/photos/fulcrum-160.jpg";
import fulcrum_card320 from "../assets/photos/fulcrum-320.jpg";
import fulcrum_card640 from "../assets/photos/fulcrum-640.jpg";
import fulcrum_hero640 from "../assets/photos/fulcrum-hero-640.jpg";
import fulcrum_hero1200 from "../assets/photos/fulcrum-hero-1200.jpg";
import fulcrum_hero2000 from "../assets/photos/fulcrum-hero-2000.jpg";
import harrier_card160 from "../assets/photos/harrier-160.jpg";
import harrier_card320 from "../assets/photos/harrier-320.jpg";
import harrier_card640 from "../assets/photos/harrier-640.jpg";
import harrier_hero640 from "../assets/photos/harrier-hero-640.jpg";
import harrier_hero1200 from "../assets/photos/harrier-hero-1200.jpg";
import harrier_hero2000 from "../assets/photos/harrier-hero-2000.jpg";
import hercules_card160 from "../assets/photos/hercules-160.jpg";
import hercules_card320 from "../assets/photos/hercules-320.jpg";
import hercules_card640 from "../assets/photos/hercules-640.jpg";
import hercules_hero640 from "../assets/photos/hercules-hero-640.jpg";
import hercules_hero1200 from "../assets/photos/hercules-hero-1200.jpg";
import hercules_hero2000 from "../assets/photos/hercules-hero-2000.jpg";
import hind_card160 from "../assets/photos/hind-160.jpg";
import hind_card320 from "../assets/photos/hind-320.jpg";
import hind_card640 from "../assets/photos/hind-640.jpg";
import hind_hero640 from "../assets/photos/hind-hero-640.jpg";
import hind_hero1200 from "../assets/photos/hind-hero-1200.jpg";
import hind_hero2000 from "../assets/photos/hind-hero-2000.jpg";
import hip_card160 from "../assets/photos/hip-160.jpg";
import hip_card320 from "../assets/photos/hip-320.jpg";
import hip_card640 from "../assets/photos/hip-640.jpg";
import hip_hero640 from "../assets/photos/hip-hero-640.jpg";
import hip_hero1200 from "../assets/photos/hip-hero-1200.jpg";
import hip_hero2000 from "../assets/photos/hip-hero-2000.jpg";
import huey_card160 from "../assets/photos/huey-160.jpg";
import huey_card320 from "../assets/photos/huey-320.jpg";
import huey_card640 from "../assets/photos/huey-640.jpg";
import huey_hero640 from "../assets/photos/huey-hero-640.jpg";
import huey_hero1200 from "../assets/photos/huey-hero-1200.jpg";
import huey_hero2000 from "../assets/photos/huey-hero-2000.jpg";
import kiowa_card160 from "../assets/photos/kiowa-160.jpg";
import kiowa_card320 from "../assets/photos/kiowa-320.jpg";
import kiowa_card640 from "../assets/photos/kiowa-640.jpg";
import kiowa_hero640 from "../assets/photos/kiowa-hero-640.jpg";
import kiowa_hero1200 from "../assets/photos/kiowa-hero-1200.jpg";
import kiowa_hero2000 from "../assets/photos/kiowa-hero-2000.jpg";
import mig21_card160 from "../assets/photos/mig21-160.jpg";
import mig21_card320 from "../assets/photos/mig21-320.jpg";
import mig21_card640 from "../assets/photos/mig21-640.jpg";
import mig21_hero640 from "../assets/photos/mig21-hero-640.jpg";
import mig21_hero1200 from "../assets/photos/mig21-hero-1200.jpg";
import mig21_hero2000 from "../assets/photos/mig21-hero-2000.jpg";
import mirage2000_card160 from "../assets/photos/mirage2000-160.jpg";
import mirage2000_card320 from "../assets/photos/mirage2000-320.jpg";
import mirage2000_card640 from "../assets/photos/mirage2000-640.jpg";
import mirage2000_hero640 from "../assets/photos/mirage2000-hero-640.jpg";
import mirage2000_hero1200 from "../assets/photos/mirage2000-hero-1200.jpg";
import mirage2000_hero2000 from "../assets/photos/mirage2000-hero-2000.jpg";
import miragef1_card160 from "../assets/photos/miragef1-160.jpg";
import miragef1_card320 from "../assets/photos/miragef1-320.jpg";
import miragef1_card640 from "../assets/photos/miragef1-640.jpg";
import miragef1_hero640 from "../assets/photos/miragef1-hero-640.jpg";
import miragef1_hero1200 from "../assets/photos/miragef1-hero-1200.jpg";
import miragef1_hero2000 from "../assets/photos/miragef1-hero-2000.jpg";
import phantom_card160 from "../assets/photos/phantom-160.jpg";
import phantom_card320 from "../assets/photos/phantom-320.jpg";
import phantom_card640 from "../assets/photos/phantom-640.jpg";
import phantom_hero640 from "../assets/photos/phantom-hero-640.jpg";
import phantom_hero1200 from "../assets/photos/phantom-hero-1200.jpg";
import phantom_hero2000 from "../assets/photos/phantom-hero-2000.jpg";
import tomcat_card160 from "../assets/photos/tomcat-160.jpg";
import tomcat_card320 from "../assets/photos/tomcat-320.jpg";
import tomcat_card640 from "../assets/photos/tomcat-640.jpg";
import tomcat_hero640 from "../assets/photos/tomcat-hero-640.jpg";
import tomcat_hero1200 from "../assets/photos/tomcat-hero-1200.jpg";
import tomcat_hero2000 from "../assets/photos/tomcat-hero-2000.jpg";
import viggen_card160 from "../assets/photos/viggen-160.jpg";
import viggen_card320 from "../assets/photos/viggen-320.jpg";
import viggen_card640 from "../assets/photos/viggen-640.jpg";
import viggen_hero640 from "../assets/photos/viggen-hero-640.jpg";
import viggen_hero1200 from "../assets/photos/viggen-hero-1200.jpg";
import viggen_hero2000 from "../assets/photos/viggen-hero-2000.jpg";
import viper_card160 from "../assets/photos/viper-160.jpg";
import viper_card320 from "../assets/photos/viper-320.jpg";
import viper_card640 from "../assets/photos/viper-640.jpg";
import viper_hero640 from "../assets/photos/viper-hero-640.jpg";
import viper_hero1200 from "../assets/photos/viper-hero-1200.jpg";
import viper_hero2000 from "../assets/photos/viper-hero-2000.jpg";
import warthog_card160 from "../assets/photos/warthog-160.jpg";
import warthog_card320 from "../assets/photos/warthog-320.jpg";
import warthog_card640 from "../assets/photos/warthog-640.jpg";
import warthog_hero640 from "../assets/photos/warthog-hero-640.jpg";
import warthog_hero1200 from "../assets/photos/warthog-hero-1200.jpg";
import warthog_hero2000 from "../assets/photos/warthog-hero-2000.jpg";
import asat_card160 from "../assets/photos/asat-160.jpg";
import asat_card320 from "../assets/photos/asat-320.jpg";
import asat_card640 from "../assets/photos/asat-640.jpg";
import asat_hero640 from "../assets/photos/asat-hero-640.jpg";
import asat_hero1200 from "../assets/photos/asat-hero-1200.jpg";
import asat_hero2000 from "../assets/photos/asat-hero-2000.jpg";
import lso_card160 from "../assets/photos/lso-160.jpg";
import lso_card320 from "../assets/photos/lso-320.jpg";
import lso_card640 from "../assets/photos/lso-640.jpg";
import lso_hero640 from "../assets/photos/lso-hero-640.jpg";
import lso_hero1200 from "../assets/photos/lso-hero-1200.jpg";
import lso_hero2000 from "../assets/photos/lso-hero-2000.jpg";
import cockpit_card160 from "../assets/photos/cockpit-160.jpg";
import cockpit_card320 from "../assets/photos/cockpit-320.jpg";
import cockpit_card640 from "../assets/photos/cockpit-640.jpg";
import cockpit_hero640 from "../assets/photos/cockpit-hero-640.jpg";
import cockpit_hero1200 from "../assets/photos/cockpit-hero-1200.jpg";
import cockpit_hero2000 from "../assets/photos/cockpit-hero-2000.jpg";
import pilots_card160 from "../assets/photos/pilots-160.jpg";
import pilots_card320 from "../assets/photos/pilots-320.jpg";
import pilots_card640 from "../assets/photos/pilots-640.jpg";
import pilots_hero640 from "../assets/photos/pilots-hero-640.jpg";
import pilots_hero1200 from "../assets/photos/pilots-hero-1200.jpg";
import pilots_hero2000 from "../assets/photos/pilots-hero-2000.jpg";

export const PHOTOS = {
  strike_eagle: { card160: strike_eagle_card160, card320: strike_eagle_card320, card640: strike_eagle_card640, hero640: strike_eagle_hero640, hero1200: strike_eagle_hero1200, hero2000: strike_eagle_hero2000 },
  hornet_sunset: { card160: hornet_sunset_card160, card320: hornet_sunset_card320, card640: hornet_sunset_card640, hero640: hornet_sunset_hero640, hero1200: hornet_sunset_hero1200, hero2000: hornet_sunset_hero2000 },
  f15: { card160: f15_card160, card320: f15_card320, card640: f15_card640, hero640: f15_hero640, hero1200: f15_hero1200, hero2000: f15_hero2000 },
  flanker: { card160: flanker_card160, card320: flanker_card320, card640: flanker_card640, hero640: flanker_hero640, hero1200: flanker_hero1200, hero2000: flanker_hero2000 },
  a10_formation: { card160: a10_formation_card160, card320: a10_formation_card320, card640: a10_formation_card640, hero640: a10_formation_hero640, hero1200: a10_formation_hero1200, hero2000: a10_formation_hero2000 },
  apache: { card160: apache_card160, card320: apache_card320, card640: apache_card640, hero640: apache_hero640, hero1200: apache_hero1200, hero2000: apache_hero2000 },
  blackshark: { card160: blackshark_card160, card320: blackshark_card320, card640: blackshark_card640, hero640: blackshark_hero640, hero1200: blackshark_hero1200, hero2000: blackshark_hero2000 },
  fulcrum: { card160: fulcrum_card160, card320: fulcrum_card320, card640: fulcrum_card640, hero640: fulcrum_hero640, hero1200: fulcrum_hero1200, hero2000: fulcrum_hero2000 },
  harrier: { card160: harrier_card160, card320: harrier_card320, card640: harrier_card640, hero640: harrier_hero640, hero1200: harrier_hero1200, hero2000: harrier_hero2000 },
  hercules: { card160: hercules_card160, card320: hercules_card320, card640: hercules_card640, hero640: hercules_hero640, hero1200: hercules_hero1200, hero2000: hercules_hero2000 },
  hind: { card160: hind_card160, card320: hind_card320, card640: hind_card640, hero640: hind_hero640, hero1200: hind_hero1200, hero2000: hind_hero2000 },
  hip: { card160: hip_card160, card320: hip_card320, card640: hip_card640, hero640: hip_hero640, hero1200: hip_hero1200, hero2000: hip_hero2000 },
  huey: { card160: huey_card160, card320: huey_card320, card640: huey_card640, hero640: huey_hero640, hero1200: huey_hero1200, hero2000: huey_hero2000 },
  kiowa: { card160: kiowa_card160, card320: kiowa_card320, card640: kiowa_card640, hero640: kiowa_hero640, hero1200: kiowa_hero1200, hero2000: kiowa_hero2000 },
  mig21: { card160: mig21_card160, card320: mig21_card320, card640: mig21_card640, hero640: mig21_hero640, hero1200: mig21_hero1200, hero2000: mig21_hero2000 },
  mirage2000: { card160: mirage2000_card160, card320: mirage2000_card320, card640: mirage2000_card640, hero640: mirage2000_hero640, hero1200: mirage2000_hero1200, hero2000: mirage2000_hero2000 },
  miragef1: { card160: miragef1_card160, card320: miragef1_card320, card640: miragef1_card640, hero640: miragef1_hero640, hero1200: miragef1_hero1200, hero2000: miragef1_hero2000 },
  phantom: { card160: phantom_card160, card320: phantom_card320, card640: phantom_card640, hero640: phantom_hero640, hero1200: phantom_hero1200, hero2000: phantom_hero2000 },
  tomcat: { card160: tomcat_card160, card320: tomcat_card320, card640: tomcat_card640, hero640: tomcat_hero640, hero1200: tomcat_hero1200, hero2000: tomcat_hero2000 },
  viggen: { card160: viggen_card160, card320: viggen_card320, card640: viggen_card640, hero640: viggen_hero640, hero1200: viggen_hero1200, hero2000: viggen_hero2000 },
  viper: { card160: viper_card160, card320: viper_card320, card640: viper_card640, hero640: viper_hero640, hero1200: viper_hero1200, hero2000: viper_hero2000 },
  warthog: { card160: warthog_card160, card320: warthog_card320, card640: warthog_card640, hero640: warthog_hero640, hero1200: warthog_hero1200, hero2000: warthog_hero2000 },
  asat: { card160: asat_card160, card320: asat_card320, card640: asat_card640, hero640: asat_hero640, hero1200: asat_hero1200, hero2000: asat_hero2000 },
  lso: { card160: lso_card160, card320: lso_card320, card640: lso_card640, hero640: lso_hero640, hero1200: lso_hero1200, hero2000: lso_hero2000 },
  cockpit: { card160: cockpit_card160, card320: cockpit_card320, card640: cockpit_card640, hero640: cockpit_hero640, hero1200: cockpit_hero1200, hero2000: cockpit_hero2000 },
  pilots: { card160: pilots_card160, card320: pilots_card320, card640: pilots_card640, hero640: pilots_hero640, hero1200: pilots_hero1200, hero2000: pilots_hero2000 },
};

export type PhotoKey = keyof typeof PHOTOS;
export type HeroKey = "strike_eagle" | "hornet_sunset" | "f15" | "flanker" | "a10_formation" | "apache" | "blackshark" | "fulcrum" | "harrier" | "hercules" | "hind" | "hip" | "huey" | "kiowa" | "mig21" | "mirage2000" | "miragef1" | "phantom" | "tomcat" | "viggen" | "viper" | "warthog" | "lso" | "asat" | "cockpit" | "pilots";

type CardSizes = "card160" | "card320" | "card640";
type HeroSizes = "hero640" | "hero1200" | "hero2000";

const supportsUnprefixed = typeof CSS !== "undefined" && CSS.supports("background-image", "image-set(url(a.jpg) 1x)");

function imageSet(oneX: string, twoX: string): string {
  const prefix = supportsUnprefixed ? "image-set" : "-webkit-image-set";
  return `${prefix}(url(${oneX}) 1x, url(${twoX}) 2x)`;
}

export function cardImage(key: PhotoKey, size: "thumb" | "tile"): string {
  const files = PHOTOS[key] as Record<CardSizes, string>;
  return size === "thumb" ? imageSet(files.card160, files.card320) : imageSet(files.card320, files.card640);
}

export function heroImage(key: HeroKey, size: "sm" | "md" | "lg"): string {
  const files = PHOTOS[key] as Record<HeroSizes, string>;
  return size === "sm" ? imageSet(files.hero640, files.hero1200) : imageSet(files.hero1200, files.hero2000);
}
